import gql from 'graphql-tag';

export const productFragment = gql`
fragment ListProductPageProduct on Product {
  id
  brand
  category {
    id
    canonicalName
  }
  country
  desProductId
  name
  photo {
    url
  }
}
`;

export const getProductQL = gql`
  query($id: ID!) {
    product(id: $id) {
      id
      ...ListProductPageProduct
    }
  }
  ${productFragment}
`;

export const searchProductQL = gql`
  query($query: String!, $country: String!) {
    searchResult: searchProduct(query: $query, country: $country, first: 25) {
      edges {
        node {
          id
          ...ListProductPageProduct
        }
      }
    }
  }
  ${productFragment}
`;
